import { render, staticRenderFns } from "./Result2.vue?vue&type=template&id=a6fc51fc&scoped=true"
import script from "./Result2.vue?vue&type=script&lang=js"
export * from "./Result2.vue?vue&type=script&lang=js"
import style0 from "./Result2.vue?vue&type=style&index=0&id=a6fc51fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fc51fc",
  null
  
)

export default component.exports